(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function track(name, props) {
    try {
      if (typeof window.msTrack === 'function') window.msTrack(name, props || {});
      else if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, props || {});
      }
    } catch (e) {}
  }

  ready(function () {
    var root = document.querySelector('[data-ms-pdp]');
    if (!root) return;

    var primaryCta = root.querySelector('.ms-pdp-gallery [data-open-preview]');
    if (primaryCta && !root.querySelector('[data-pdp-sticky-cta]')) {
      var mobileCtaQuery = window.matchMedia('(max-width: 1023px)');
      var stickyBar = document.createElement('div');
      stickyBar.className = 'ms-pdp-sticky-cta';
      stickyBar.setAttribute('data-pdp-sticky-cta', '');
      stickyBar.hidden = true;
      var stickyButton = document.createElement('button');
      stickyButton.type = 'button';
      stickyButton.className = 'ms-pdp-cta';
      stickyButton.innerHTML = primaryCta.innerHTML;
      stickyBar.appendChild(stickyButton);
      root.appendChild(stickyBar);

      function updateStickyCta() {
        var passed = primaryCta.getBoundingClientRect().bottom <= 0;
        stickyBar.hidden = !mobileCtaQuery.matches || !passed || document.body.classList.contains('ms-wiz-open');
        stickyButton.disabled = primaryCta.disabled;
      }

      stickyButton.addEventListener('click', function () {
        if (!primaryCta.disabled) primaryCta.click();
        updateStickyCta();
      });
      var stickyObserver = new IntersectionObserver(updateStickyCta, { threshold: 0 });
      stickyObserver.observe(primaryCta);
      var stickyStateObserver = new MutationObserver(updateStickyCta);
      stickyStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      stickyStateObserver.observe(primaryCta, { attributes: true, attributeFilter: ['disabled'] });
      window.addEventListener('resize', updateStickyCta);
      updateStickyCta();
    }

    var productHandle = root.getAttribute('data-product-handle') || '';
    var productTitle = root.getAttribute('data-product-title') || (document.title || '');

    function baseProps(extra) {
      var props = {
        product_handle: productHandle,
        product_title: productTitle
      };
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          props[k] = extra[k];
        });
      }
      return props;
    }

    track('pdp_viewed', baseProps());

    var carousel = root.querySelector('[data-pdp-carousel]');
    var dots = root.querySelectorAll('[data-pdp-dot]');
    var slides = root.querySelectorAll('.ms-pdp-slide');

    function setActive(index) {
      slides.forEach(function (slide) {
        var active = Number(slide.getAttribute('data-slide-index')) === index;
        slide.classList.toggle('is-active', active);
        var video = slide.querySelector('video');
        if (video) {
          if (active) {
            try { video.play(); } catch (e) {}
          } else {
            try { video.pause(); } catch (e) {}
          }
        }
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', Number(d.getAttribute('data-pdp-dot')) === index);
        d.setAttribute('aria-current', Number(d.getAttribute('data-pdp-dot')) === index ? 'true' : 'false');
      });
    }

    function goTo(index, source) {
      setActive(index);
      if (carousel) {
        carousel.scrollTo({ left: index * carousel.clientWidth, behavior: 'smooth' });
      }
      track('pdp_gallery_navigated', baseProps({
        image_index: index,
        source: source || 'unknown'
      }));
    }

    if (carousel) {
      var lastScrollIndex = 0;
      carousel.addEventListener('scroll', function () {
        var w = carousel.clientWidth || 1;
        var index = Math.round(carousel.scrollLeft / w);
        setActive(index);
        // Pause/play videos in mobile carousel slides
        carousel.querySelectorAll('[data-pdp-scroll-slide]').forEach(function (slide) {
          var video = slide.querySelector('video');
          if (!video) return;
          var active = Number(slide.getAttribute('data-pdp-scroll-slide')) === index;
          try {
            if (active) video.play();
            else video.pause();
          } catch (e) {}
        });
        if (index !== lastScrollIndex) {
          lastScrollIndex = index;
          track('pdp_gallery_scrolled', baseProps({ image_index: index }));
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-pdp-dot')) || 0, 'dot');
      });
    });

    root.querySelectorAll('[data-gallery-direction]').forEach(function (button) {
      button.addEventListener('click', function () {
        var active = root.querySelector('.ms-pdp-slide.is-active');
        var index = active ? Number(active.getAttribute('data-slide-index')) : 0;
        if (slides.length) goTo((index + Number(button.getAttribute('data-gallery-direction')) + slides.length) % slides.length, 'arrow');
      });
    });

    var more = root.querySelector('[data-showmore]');
    var desc = root.querySelector('[data-desc]');
    if (more && desc) {
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Show more';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        track('pdp_description_toggled', baseProps({ expanded: open }));
      });
    }

    var plans = root.querySelectorAll('[data-plan]');
    var variantsJson = root.querySelector('[data-ms-variants]');
    var variantsMap = null;
    try {
      if (variantsJson) variantsMap = JSON.parse(variantsJson.textContent || '{}');
    } catch (e) {
      variantsMap = null;
    }

    function formatMoneyFromCents(cents) {
      var n = Number(cents || 0) / 100;
      return '€' + n.toFixed(2).replace('.', ',');
    }

    function applyVariant(planKey, variantId) {
      var data = variantsMap && variantsMap[planKey];
      var priceEl = root.querySelector('[data-ms-price]');
      var compareEl = root.querySelector('[data-ms-compare]');
      var saveEl = root.querySelector('[data-ms-save]');
      if (data) {
        if (priceEl) priceEl.textContent = data.price_money || formatMoneyFromCents(data.price);
        var hasDiscount = Number(data.compare || 0) > Number(data.price || 0);
        if (compareEl) {
          if (hasDiscount) {
            compareEl.hidden = false;
            compareEl.innerHTML = '<s>' + (data.compare_money || formatMoneyFromCents(data.compare)) + '</s>';
          } else {
            compareEl.hidden = true;
            compareEl.innerHTML = '<s></s>';
          }
        }
        if (saveEl) {
          if (hasDiscount) {
            saveEl.hidden = false;
            saveEl.style.display = '';
            saveEl.textContent = '-' + Math.round((Number(data.compare) - Number(data.price)) * 100 / Number(data.compare)) + '%';
          } else {
            saveEl.hidden = true;
            saveEl.style.display = 'none';
            saveEl.textContent = '';
          }
        }
        variantId = String(data.id);
      }
      if (variantId) {
        root.setAttribute('data-variant-id', String(variantId));
        var previewRoot = document.querySelector('[data-ms-preview]');
        if (previewRoot) previewRoot.setAttribute('data-variant-id', String(variantId));
        try {
          if (window.msPreviewState) window.msPreviewState.variantId = String(variantId);
        } catch (e) {}
      }
    }

    plans.forEach(function (plan) {
      function selectPlan() {
        plans.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-pressed', 'false');
        });
        plan.classList.add('is-selected');
        plan.setAttribute('aria-pressed', 'true');
        var planKey = plan.getAttribute('data-plan') || 'unknown';
        var variantId = plan.getAttribute('data-variant-id');
        applyVariant(planKey, variantId);
        track('pdp_plan_selected', baseProps({
          plan: planKey,
          plan_label: (plan.querySelector('.ms-plan-name') || {}).textContent || null,
          variant_id: variantId || null
        }));
      }
      plan.addEventListener('click', selectPlan);
      plan.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPlan();
        }
      });
    });

    var rail = root.querySelector('[data-related-rail]');
    var prev = root.querySelector('[data-related-prev]');
    var next = root.querySelector('[data-related-next]');
    function scrollRelated(dir) {
      if (!rail) return;
      var amount = Math.min(320, rail.clientWidth * 0.8) * dir;
      rail.scrollBy({ left: amount, behavior: 'smooth' });
      track('pdp_related_scrolled', baseProps({ direction: dir > 0 ? 'next' : 'prev' }));
    }
    if (prev) prev.addEventListener('click', function () { scrollRelated(-1); });
    if (next) next.addEventListener('click', function () { scrollRelated(1); });

    var stickerAtc = root.querySelector('.ms-pdp-form form, .ms-pdp-form button[name="add"]');
    if (stickerAtc) {
      var form = stickerAtc.tagName === 'FORM' ? stickerAtc : stickerAtc.closest('form');
      if (form) {
        form.addEventListener('submit', function () {
          track('pdp_add_to_cart_clicked', baseProps({ product_kind: 'sticker' }));
        });
      }
    }

    var ship72 = root.querySelector('[data-ms-ship72]');
    if (ship72) {
      var shipTrigger = ship72.querySelector('[data-ms-ship72-trigger]');
      var shipPanel = ship72.querySelector('[data-ms-ship72-panel]');
      var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;

      function openShip72() {
        if (!shipPanel) return;
        shipPanel.hidden = false;
        ship72.classList.add('is-open');
        if (shipTrigger) shipTrigger.setAttribute('aria-expanded', 'true');
        track('pdp_ship72_opened', baseProps({ mode: coarse ? 'tap' : 'hover_or_click' }));
      }

      function closeShip72() {
        if (!shipPanel) return;
        shipPanel.hidden = true;
        ship72.classList.remove('is-open');
        if (shipTrigger) shipTrigger.setAttribute('aria-expanded', 'false');
      }

      if (shipTrigger) {
        shipTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (ship72.classList.contains('is-open')) closeShip72();
          else openShip72();
        });
      }

      if (!coarse && shipTrigger) {
        ship72.addEventListener('mouseenter', openShip72);
        ship72.addEventListener('mouseleave', closeShip72);
      }

      ship72.querySelectorAll('[data-ms-ship72-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeShip72();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ship72.classList.contains('is-open')) closeShip72();
      });

      document.addEventListener('click', function (e) {
        if (!ship72.classList.contains('is-open')) return;
        if (!ship72.contains(e.target)) closeShip72();
      });
    }
  });
})();
